"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageNotFoundFallbackComponent = exports.createErrorBoundary = exports.ErrorBoundary = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const bugsnag_react_1 = __importDefault(require("bugsnag-react"));
const logger_1 = __importDefault(require("../../utils/logger"));
const SidebarLogo_1 = __importDefault(require("../base-components/SidebarLogo"));
const DefaultFallbackComponent = ({ className = "", }) => (React.createElement("div", { className: `error-boundary ${className}` },
    React.createElement("div", null,
        React.createElement("h1", { className: "error-boundary-title" }, "Oops! Looks like we're having trouble displaying this data.")),
    React.createElement("div", null,
        React.createElement("h5", { className: "error-boundary-text" }, "We've been notified and are on it."))));
class InternalErrorComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        logger_1.default.error(error, errorInfo);
    }
    render() {
        const { children, className, FallbackComponent } = this.props;
        if (this.state.hasError) {
            return React.createElement(FallbackComponent, { className: className });
        }
        return children;
    }
}
InternalErrorComponent.defaultProps = {
    className: "",
    FallbackComponent: DefaultFallbackComponent,
};
const bugsnagClient = window.bugsnagClient;
let _ErrorBoundary = InternalErrorComponent;
if (bugsnagClient) {
    bugsnagClient.app.version = process.env.WEB_APP_VERSION;
    _ErrorBoundary = bugsnagClient.use((0, bugsnag_react_1.default)(React));
}
exports.ErrorBoundary = _ErrorBoundary;
const createErrorBoundary = (isSidebar = false) => (Component) => {
    let FallbackComponent;
    if (isSidebar) {
        FallbackComponent = SidebarFallbackComponent;
    }
    else {
        FallbackComponent = DefaultFallbackComponent;
    }
    const ErrorWrapper = (props) => (React.createElement(exports.ErrorBoundary, { FallbackComponent: FallbackComponent },
        React.createElement(Component, { ...props })));
    return ErrorWrapper;
};
exports.createErrorBoundary = createErrorBoundary;
const PageNotFoundFallbackComponent = () => {
    return (React.createElement("div", { className: "error-boundary below-nav" },
        React.createElement("div", null,
            React.createElement("h4", { className: "error-boundary-title" }, "Oops! This isn't the page you're looking for.")),
        React.createElement("div", null,
            React.createElement("h5", { className: "error-boundary-text" },
                "Return to the",
                React.createElement(react_router_dom_1.Link, { to: "/" },
                    React.createElement("span", { className: "error-boundary-link ml-1" }, "previous page")),
                "."))));
};
exports.PageNotFoundFallbackComponent = PageNotFoundFallbackComponent;
const SidebarFallbackComponent = () => (React.createElement("div", { className: "sidebar-flex-wrapper" },
    React.createElement("div", { className: "sidebar-container" },
        React.createElement(react_router_dom_1.Link, { to: "/" },
            React.createElement(SidebarLogo_1.default, { isCollapsed: false }))),
    React.createElement(DefaultFallbackComponent, null)));
exports.default = exports.createErrorBoundary;
